<template>
  <div class="tw-min-h-[calc(100vh-146px)] tw-bg-bgPage tw-text-forTitle">
    <BaseTopLine></BaseTopLine>
    <div>
      <VueTabs v-if="!localLoading" class="vue-tabs-type-1">
        <VTab title="Договоры" class="tw-px-[26px]">
          <div
            class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-my-[15px]"
          >
            <div class="tw-w-1/3">
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_1
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_1
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_1
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_2
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_2
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_2
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_4
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_4
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_4
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_22
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_22
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_22
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_5
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_5
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_5
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_6
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_6
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_6
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_7
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_7
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_7
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
            </div>
          </div>
        </VTab>
        <VTab title="Доступы" class="tw-px-[26px]">
          <div
            class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-my-[15px]"
          >
            <div
              class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[5px]"
            >
              SMSimple
            </div>
            <div class="tw-w-1/3">
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.sms_simple_login
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.sms_simple_login
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.sms_simple_login
                    .company_settings_super__description
                "
              >
              </BaseInputNew>

              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.sms_simple_password
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.sms_simple_password
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.sms_simple_password
                    .company_settings_super__description
                "
              >
              </BaseInputNew>

              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.sms_simple_id
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.sms_simple_id
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.sms_simple_id
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
            </div>
          </div>
        </VTab>
        <VTab title="Платные услуги" class="tw-px-[26px]">
          <div
            class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-my-[15px]"
          >
            <div class="tw-w-1/3">
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.sms_cost.company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.sms_cost.company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.sms_cost.company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_47
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_47
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_47
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.fine_cost_month
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.fine_cost_month
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.fine_cost_month
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_33
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_33
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_33
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_34
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_34
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_34
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_35
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_35
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_35
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_36
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_36
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_36
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_37
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_37
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_37
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_38
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_38
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_38
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_39
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_39
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_39
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_40
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_40
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_40
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_41
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_41
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_41
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_42
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_42
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_42
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_43
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_43
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_43
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <BaseInputNew
                inputClass="tw-app-input-type-2"
                class="tw-mb-[5px]"
                :width="'250'"
                :input-name="
                  dataFromSetting.crm_setting_44
                    .company_settings_super__setting_key
                "
                @input="updateValue"
                :value="
                  dataFromSetting.crm_setting_44
                    .company_settings_super__setting_value
                "
                :name-sign="
                  dataFromSetting.crm_setting_44
                    .company_settings_super__description
                "
              >
              </BaseInputNew>
              <!-- таска 63817468 -->
              <div
                class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mt-[20px] tw-mb-[5px]"
              >
                Тарифы на подписку "Штрафы и ПД"
              </div>
              <div v-for="field in tariffsAndFineControlFields" :key="field">
                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[5px]"
                  :width="'250'"
                  :input-name="
                    dataFromSetting[field].company_settings_super__setting_key
                  "
                  @input="updateValue"
                  :value="
                    dataFromSetting[field].company_settings_super__setting_value
                  "
                  :name-sign="
                    dataFromSetting[field].company_settings_super__description
                      ?.split('.')
                      ?.at(-1)
                      ?.trim()
                  "
                >
                </BaseInputNew>
              </div>
              <!-- таска 63817468 -->
            </div>
          </div>
        </VTab>
        <VTab title="Прочее" class="tw-px-[26px]">
          <div class="tw-grid tw-grid-cols-[6fr_4fr] tw-gap-[15px]">
            <div
              class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-my-[15px]"
            >
              <div class="tw-w-[55%] tw-relative">
                <div v-if="dataFromSetting.crm_setting_74">
                  <BaseInputNew
                    inputClass="tw-app-input-type-2"
                    class="tw-mb-[5px]"
                    :width="'250'"
                    inputRef="crm_setting_74"
                    :input-name="
                      dataFromSetting.crm_setting_74
                        .company_settings_super__setting_key
                    "
                    @input="updateValue"
                    :value="
                      dataFromSetting.crm_setting_74
                        .company_settings_super__setting_value
                    "
                    name-sign="Ссылка на сайт для создания QR кода в 718 разделе"
                  />
                </div>

                <div v-if="dataFromSetting.crm_setting_77" class="tw-mb-[5px]">
                  <BaseInputNew
                    inputClass="tw-app-input-type-2"
                    :width="'250'"
                    inputRef="crm_setting_77"
                    maxLength="6"
                    :input-name="
                      dataFromSetting.crm_setting_77
                        .company_settings_super__setting_key
                    "
                    @input="updateValue"
                    :value="
                      dataFromSetting.crm_setting_77
                        .company_settings_super__setting_value
                    "
                    :name-sign="
                      dataFromSetting.crm_setting_77
                        .company_settings_super__description
                    "
                    :inputMask="{
                      mask: Number,
                      scale: 2,
                      signed: false,
                      min: 0,
                      max: 20,
                      thousandsSeparator: '',
                      padFractionalZeros: true,
                      normalizeZeros: true,
                      radix: '.',
                      mapToRadix: [','],
                    }"
                  />
                  <div
                    class="tw-text-[10px] tw-text-lightText tw-absolute tw-right-0 tw-mt-[2px]"
                  >
                    Допустимые значения: от 0.00 до 20.00 %
                  </div>
                </div>

                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mt-[30px] tw-mb-[5px]"
                >
                  Разработка
                </div>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[5px]"
                  :width="'250'"
                  :input-name="
                    dataFromSetting.crm_setting_20
                      .company_settings_super__setting_key
                  "
                  @input="updateValue"
                  :value="
                    dataFromSetting.crm_setting_20
                      .company_settings_super__setting_value
                  "
                  :name-sign="
                    dataFromSetting.crm_setting_20
                      .company_settings_super__description
                  "
                >
                </BaseInputNew>

                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mt-[20px] tw-mb-[5px]"
                >
                  Настройки таймеров
                </div>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[5px]"
                  :width="'250'"
                  :input-name="
                    dataFromSetting.timer_order_status_new
                      .company_settings_super__setting_key
                  "
                  @input="updateValue"
                  :value="
                    dataFromSetting.timer_order_status_new
                      .company_settings_super__setting_value
                  "
                  :name-sign="
                    dataFromSetting.timer_order_status_new
                      .company_settings_super__description
                  "
                >
                </BaseInputNew>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[5px]"
                  :width="'250'"
                  :input-name="
                    dataFromSetting.timer_order_status_consulation
                      .company_settings_super__setting_key
                  "
                  @input="updateValue"
                  :value="
                    dataFromSetting.timer_order_status_consulation
                      .company_settings_super__setting_value
                  "
                  :name-sign="
                    dataFromSetting.timer_order_status_consulation
                      .company_settings_super__description
                  "
                >
                </BaseInputNew>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[5px]"
                  :width="'250'"
                  :input-name="
                    dataFromSetting.timer_order_status_confirmed
                      .company_settings_super__setting_key
                  "
                  @input="updateValue"
                  :value="
                    dataFromSetting.timer_order_status_confirmed
                      .company_settings_super__setting_value
                  "
                  :name-sign="
                    dataFromSetting.timer_order_status_confirmed
                      .company_settings_super__description
                  "
                >
                </BaseInputNew>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[5px]"
                  :width="'250'"
                  :input-name="
                    dataFromSetting.timer_order_status_security
                      .company_settings_super__setting_key
                  "
                  @input="updateValue"
                  :value="
                    dataFromSetting.timer_order_status_security
                      .company_settings_super__setting_value
                  "
                  :name-sign="
                    dataFromSetting.timer_order_status_security
                      .company_settings_super__description
                  "
                >
                </BaseInputNew>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[5px]"
                  :width="'250'"
                  :input-name="
                    dataFromSetting.timer_order_status_contract
                      .company_settings_super__setting_key
                  "
                  @input="updateValue"
                  :value="
                    dataFromSetting.timer_order_status_contract
                      .company_settings_super__setting_value
                  "
                  :name-sign="
                    dataFromSetting.timer_order_status_contract
                      .company_settings_super__description
                  "
                >
                </BaseInputNew>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[5px]"
                  :width="'250'"
                  :input-name="
                    dataFromSetting.timer_order_status_fill_anket
                      .company_settings_super__setting_key
                  "
                  @input="updateValue"
                  :value="
                    dataFromSetting.timer_order_status_fill_anket
                      .company_settings_super__setting_value
                  "
                  :name-sign="
                    dataFromSetting.timer_order_status_fill_anket
                      .company_settings_super__description
                  "
                >
                </BaseInputNew>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[5px]"
                  :width="'250'"
                  :input-name="
                    dataFromSetting.timer_order_status_payment
                      .company_settings_super__setting_key
                  "
                  @input="updateValue"
                  :value="
                    dataFromSetting.timer_order_status_payment
                      .company_settings_super__setting_value
                  "
                  :name-sign="
                    dataFromSetting.timer_order_status_payment
                      .company_settings_super__description
                  "
                >
                </BaseInputNew>

                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mt-[20px] tw-mb-[5px]"
                >
                  Длина смс
                </div>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[5px]"
                  :width="'250'"
                  :input-name="
                    dataFromSetting.sms_length
                      .company_settings_super__setting_key
                  "
                  @input="updateValue"
                  :value="
                    dataFromSetting.sms_length
                      .company_settings_super__setting_value
                  "
                  :name-sign="
                    dataFromSetting.sms_length
                      .company_settings_super__description
                  "
                >
                </BaseInputNew>

                <div class="tw-mt-[20px]">
                  <BaseCheckboxV2
                    placeholder=""
                    :width="'250'"
                    :input-name="
                      dataFromSetting.crm_setting_70
                        .company_settings_super__setting_key
                    "
                    @oncheckeds="updateValue"
                    v-model="
                      dataFromSetting.crm_setting_70
                        .company_settings_super__setting_value
                    "
                    ><span class="tw-text-forText">{{
                      dataFromSetting.crm_setting_70
                        .company_settings_super__description
                    }}</span>
                  </BaseCheckboxV2>
                </div>

                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mt-[20px] tw-mb-[5px]"
                >
                  Трансляция
                </div>

                <div class="tw-flex tw-gap-[10px] tw-items-center">
                  <BaseInputNew
                    inputClass="tw-app-input-type-2"
                    class="tw-flex-grow"
                    :width="'250'"
                    :input-name="
                      dataFromSetting.crm_setting_79
                        .company_settings_super__setting_key
                    "
                    @input="updateValue"
                    :value="
                      dataFromSetting.crm_setting_79
                        .company_settings_super__setting_value
                    "
                    :name-sign="
                      dataFromSetting.crm_setting_79
                        .company_settings_super__description
                    "
                  >
                  </BaseInputNew>
                  <BaseCheckboxV2
                    :disabled="
                      !!!dataFromSetting.crm_setting_79
                        .company_settings_super__setting_value.length
                    "
                    placeholder=""
                    :width="'250'"
                    :input-name="
                      dataFromSetting.crm_setting_78
                        .company_settings_super__setting_key
                    "
                    @oncheckeds="updateValue"
                    v-model="
                      dataFromSetting.crm_setting_78
                        .company_settings_super__setting_value
                    "
                  >
                    <span class="tw-text-forText">
                      {{
                        dataFromSetting.crm_setting_78
                          .company_settings_super__description
                      }}
                    </span>
                  </BaseCheckboxV2>
                </div>
              </div>
            </div>

            <div
              class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-my-[15px]"
            >
              <div v-if="dataFromSetting" class="tw-mb-[20px]">
                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                >
                  {{
                    dataFromSetting.crm_setting_67
                      .company_settings_super__description
                  }}
                </div>
                <a
                  v-if="
                    dataFromSetting.crm_setting_67
                      .company_settings_super__setting_value
                  "
                  class="tw-text-[14px]"
                  :href="
                    dataFromSetting.crm_setting_67
                      .company_settings_super__setting_value
                  "
                  target="_blank"
                >
                  {{
                    dataFromSetting.crm_setting_67
                      .company_settings_super__setting_value
                  }}
                </a>
                <div v-else class="tw-text-[14px]">Нет файла</div>

                <div class="tw-flex tw-gap-[10px] tw-mt-[10px]">
                  <label
                    class="tw-app-btn-primary"
                    :class="{
                      disabled:
                        dataFromSetting.crm_setting_67
                          .company_settings_super__setting_value,
                    }"
                    >Добавить файл
                    <input
                      type="file"
                      class="d-none"
                      accept=".pdf, .odt, .xlsx"
                      @change="
                        uploadFile(
                          $event,
                          dataFromSetting.crm_setting_67
                            .company_settings_super__setting_key,
                          'crm_setting_67'
                        )
                      "
                  /></label>
                  <button
                    class="tw-app-btn-primary-outline"
                    :class="{
                      disabled:
                        !dataFromSetting.crm_setting_67
                          .company_settings_super__setting_value,
                    }"
                    @click="
                      updateValue({
                        name: dataFromSetting.crm_setting_67
                          .company_settings_super__setting_key,
                        value: '',
                      })
                    "
                  >
                    Удалить файл
                  </button>
                </div>
              </div>

              <div v-if="dataFromSetting" class="tw-mb-[20px]">
                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                >
                  {{
                    dataFromSetting.crm_setting_68
                      .company_settings_super__description
                  }}
                </div>
                <a
                  v-if="
                    dataFromSetting.crm_setting_68
                      .company_settings_super__setting_value
                  "
                  class="tw-text-[14px]"
                  :href="
                    dataFromSetting.crm_setting_68
                      .company_settings_super__setting_value
                  "
                  target="_blank"
                >
                  {{
                    dataFromSetting.crm_setting_68
                      .company_settings_super__setting_value
                  }}
                </a>
                <div v-else class="tw-text-[14px]">Нет файла</div>

                <div class="tw-flex tw-gap-[10px] tw-mt-[10px]">
                  <label
                    class="tw-app-btn-primary"
                    :class="{
                      disabled:
                        dataFromSetting.crm_setting_68
                          .company_settings_super__setting_value,
                    }"
                    >Добавить файл
                    <input
                      type="file"
                      class="d-none"
                      accept=".pdf, .odt, .xlsx"
                      @change="
                        uploadFile(
                          $event,
                          dataFromSetting.crm_setting_68
                            .company_settings_super__setting_key,
                          'crm_setting_68'
                        )
                      "
                  /></label>
                  <button
                    class="tw-app-btn-primary-outline"
                    :class="{
                      disabled:
                        !dataFromSetting.crm_setting_68
                          .company_settings_super__setting_value,
                    }"
                    @click="
                      updateValue({
                        name: dataFromSetting.crm_setting_68
                          .company_settings_super__setting_key,
                        value: '',
                      })
                    "
                  >
                    Удалить файл
                  </button>
                </div>
              </div>

              <!-- загрузка видео -->
              <div v-if="dataFromSetting" class="tw-mb-[20px]">
                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                >
                  {{
                    dataFromSetting.crm_setting_75
                      .company_settings_super__description
                  }}
                </div>
                <a
                  v-if="
                    dataFromSetting.crm_setting_75
                      .company_settings_super__setting_value
                  "
                  class="tw-text-[14px]"
                  :href="
                    dataFromSetting.crm_setting_75
                      .company_settings_super__setting_value
                  "
                  target="_blank"
                >
                  {{
                    dataFromSetting.crm_setting_75
                      .company_settings_super__setting_value
                  }}
                </a>
                <div v-else class="tw-text-[14px]">Нет файла</div>

                <div class="tw-flex tw-gap-[10px] tw-mt-[10px]">
                  <label
                    class="tw-app-btn-primary"
                    :class="{
                      disabled:
                        dataFromSetting.crm_setting_75
                          .company_settings_super__setting_value,
                    }"
                    >Добавить файл
                    <input
                      type="file"
                      class="d-none"
                      @change="
                        uploadFile(
                          $event,
                          dataFromSetting.crm_setting_75
                            .company_settings_super__setting_key,
                          'crm_setting_75'
                        )
                      "
                  /></label>
                  <button
                    class="tw-app-btn-primary-outline"
                    :class="{
                      disabled:
                        !dataFromSetting.crm_setting_75
                          .company_settings_super__setting_value,
                    }"
                    @click="
                      updateValue({
                        name: dataFromSetting.crm_setting_75
                          .company_settings_super__setting_key,
                        value: '',
                      })
                    "
                  >
                    Удалить файл
                  </button>
                </div>
              </div>
              <!-- загрузка видео -->

              <div v-if="dataFromSetting" class="tw-mb-[20px]">
                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                >
                  {{
                    dataFromSetting.crm_setting_50
                      .company_settings_super__description
                  }}
                </div>
                <a
                  v-if="
                    dataFromSetting.crm_setting_50
                      .company_settings_super__setting_value
                  "
                  class="tw-text-[14px]"
                  :href="
                    dataFromSetting.crm_setting_50
                      .company_settings_super__setting_value
                  "
                  target="_blank"
                >
                  {{
                    dataFromSetting.crm_setting_50
                      .company_settings_super__setting_value
                  }}
                </a>
                <div v-else class="tw-text-[14px]">Нет файла</div>

                <div class="tw-flex tw-gap-[10px] tw-mt-[10px]">
                  <label
                    class="tw-app-btn-primary"
                    :class="{
                      disabled:
                        dataFromSetting.crm_setting_50
                          .company_settings_super__setting_value,
                    }"
                    >Добавить файл
                    <input
                      type="file"
                      class="d-none"
                      accept=".pdf, .odt, .xlsx"
                      @change="
                        uploadFile(
                          $event,
                          dataFromSetting.crm_setting_50
                            .company_settings_super__setting_key,
                          'crm_setting_50'
                        )
                      "
                  /></label>
                  <button
                    class="tw-app-btn-primary-outline"
                    :class="{
                      disabled:
                        !dataFromSetting.crm_setting_50
                          .company_settings_super__setting_value,
                    }"
                    @click="
                      updateValue({
                        name: dataFromSetting.crm_setting_50
                          .company_settings_super__setting_key,
                        value: '',
                      })
                    "
                  >
                    Удалить файл
                  </button>
                </div>
              </div>

              <div v-if="dataFromSetting" class="tw-mb-[20px]">
                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                >
                  {{
                    dataFromSetting.crm_setting_80
                      .company_settings_super__description
                  }}
                </div>
                <a
                  v-if="
                    dataFromSetting.crm_setting_80
                      .company_settings_super__setting_value
                  "
                  class="tw-text-[14px]"
                  :href="
                    dataFromSetting.crm_setting_80
                      .company_settings_super__setting_value
                  "
                  target="_blank"
                >
                  {{
                    dataFromSetting.crm_setting_80
                      .company_settings_super__setting_value
                  }}
                </a>
                <div v-else class="tw-text-[14px]">Нет файла</div>

                <div class="tw-flex tw-gap-[10px] tw-mt-[10px]">
                  <label
                    class="tw-app-btn-primary"
                    :class="{
                      disabled:
                        dataFromSetting.crm_setting_80
                          .company_settings_super__setting_value,
                    }"
                    >Добавить файл
                    <input
                      type="file"
                      class="d-none"
                      accept=".pdf, .odt, .xlsx"
                      @change="
                        uploadFile(
                          $event,
                          dataFromSetting.crm_setting_80
                            .company_settings_super__setting_key,
                          'crm_setting_80'
                        )
                      "
                  /></label>
                  <button
                    class="tw-app-btn-primary-outline"
                    :class="{
                      disabled:
                        !dataFromSetting.crm_setting_80
                          .company_settings_super__setting_value,
                    }"
                    @click="
                      updateValue({
                        name: dataFromSetting.crm_setting_80
                          .company_settings_super__setting_key,
                        value: '',
                      })
                    "
                  >
                    Удалить файл
                  </button>
                </div>
              </div>

              <div v-if="dataFromSetting" class="tw-mb-[20px]">
                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                >
                  {{
                    dataFromSetting.crm_setting_76
                      .company_settings_super__description
                  }}
                </div>
                <a
                  v-if="
                    dataFromSetting.crm_setting_76
                      .company_settings_super__setting_value
                  "
                  class="tw-text-[14px]"
                  :href="
                    dataFromSetting.crm_setting_76
                      .company_settings_super__setting_value
                  "
                  target="_blank"
                >
                  {{
                    dataFromSetting.crm_setting_76
                      .company_settings_super__setting_value
                  }}
                </a>
                <div v-else class="tw-text-[14px]">Нет файла</div>

                <div class="tw-flex tw-gap-[10px] tw-mt-[10px]">
                  <label
                    class="tw-app-btn-primary"
                    :class="{
                      disabled:
                        dataFromSetting.crm_setting_76
                          .company_settings_super__setting_value,
                    }"
                  >
                    Добавить файл
                    <input
                      type="file"
                      class="d-none"
                      accept=".pdf, .odt, .xlsx"
                      @change="
                        uploadFile(
                          $event,
                          dataFromSetting.crm_setting_76
                            .company_settings_super__setting_key,
                          'crm_setting_76'
                        )
                      "
                    />
                  </label>
                  <button
                    class="tw-app-btn-primary-outline"
                    :class="{
                      disabled:
                        !dataFromSetting.crm_setting_76
                          .company_settings_super__setting_value,
                    }"
                    @click="
                      updateValue({
                        name: dataFromSetting.crm_setting_76
                          .company_settings_super__setting_key,
                        value: '',
                      })
                    "
                  >
                    Удалить файл
                  </button>
                </div>
              </div>

              <!-- загрузка звуковых оповещений -->
              <div v-if="dataFromSetting.sound_file" class="tw-mb-[20px]">
                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                >
                  Звук оповещения 101
                </div>
                <a
                  v-if="
                    dataFromSetting.sound_file
                      .company_settings_super__setting_value
                  "
                  class="tw-text-[14px]"
                  :href="
                    dataFromSetting.sound_file
                      .company_settings_super__setting_value
                  "
                  target="_blank"
                >
                  {{
                    dataFromSetting.sound_file
                      .company_settings_super__setting_value
                  }}
                </a>
                <div v-else class="tw-text-[14px]">Нет файла</div>
                <div class="tw-flex tw-gap-[10px] tw-mt-[10px]">
                  <label
                    class="tw-app-btn-primary"
                    :class="{
                      disabled:
                        dataFromSetting.sound_file
                          .company_settings_super__setting_value,
                    }"
                  >
                    Добавить файл
                    <input
                      type="file"
                      accept="audio/*"
                      class="d-none"
                      @change="
                        uploadFile(
                          $event,
                          dataFromSetting.sound_file
                            .company_settings_super__setting_key,
                          'sound_file'
                        )
                      "
                  /></label>
                  <button
                    class="tw-app-btn-primary-outline"
                    :class="{
                      disabled:
                        !dataFromSetting.sound_file
                          .company_settings_super__setting_value,
                    }"
                    @click="
                      updateValue({
                        name: dataFromSetting.sound_file
                          .company_settings_super__setting_key,
                        value: '',
                      })
                    "
                  >
                    Удалить файл
                  </button>
                </div>
              </div>

              <div v-if="dataFromSetting.crm_setting_92" class="tw-mb-[20px]">
                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                >
                  Звук оповещения 502
                </div>
                <a
                  v-if="
                    dataFromSetting.crm_setting_92
                      .company_settings_super__setting_value
                  "
                  class="tw-text-[14px]"
                  :href="
                    dataFromSetting.crm_setting_92
                      .company_settings_super__setting_value
                  "
                  target="_blank"
                >
                  {{
                    dataFromSetting.crm_setting_92
                      .company_settings_super__setting_value
                  }}
                </a>
                <div v-else class="tw-text-[14px]">Нет файла</div>
                <div class="tw-flex tw-gap-[10px] tw-mt-[10px]">
                  <label
                    class="tw-app-btn-primary"
                    :class="{
                      disabled:
                        dataFromSetting.crm_setting_92
                          .company_settings_super__setting_value,
                    }"
                  >
                    Добавить файл
                    <input
                      type="file"
                      accept="audio/*"
                      class="d-none"
                      @change="
                        uploadFile(
                          $event,
                          dataFromSetting.crm_setting_92
                            .company_settings_super__setting_key,
                          'crm_setting_92'
                        )
                      "
                  /></label>
                  <button
                    class="tw-app-btn-primary-outline"
                    :class="{
                      disabled:
                        !dataFromSetting.crm_setting_92
                          .company_settings_super__setting_value,
                    }"
                    @click="
                      updateValue({
                        name: dataFromSetting.crm_setting_92
                          .company_settings_super__setting_key,
                        value: '',
                      })
                    "
                  >
                    Удалить файл
                  </button>
                </div>
              </div>

              <div v-if="dataFromSetting.crm_setting_93" class="tw-mb-[20px]">
                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                >
                  Звук оповещения 801
                </div>
                <a
                  v-if="
                    dataFromSetting.crm_setting_93
                      .company_settings_super__setting_value
                  "
                  class="tw-text-[14px]"
                  :href="
                    dataFromSetting.crm_setting_93
                      .company_settings_super__setting_value
                  "
                  target="_blank"
                >
                  {{
                    dataFromSetting.crm_setting_93
                      .company_settings_super__setting_value
                  }}
                </a>
                <div v-else class="tw-text-[14px]">Нет файла</div>
                <div class="tw-flex tw-gap-[10px] tw-mt-[10px]">
                  <label
                    class="tw-app-btn-primary"
                    :class="{
                      disabled:
                        dataFromSetting.crm_setting_93
                          .company_settings_super__setting_value,
                    }"
                  >
                    Добавить файл
                    <input
                      type="file"
                      accept="audio/*"
                      class="d-none"
                      @change="
                        uploadFile(
                          $event,
                          dataFromSetting.crm_setting_93
                            .company_settings_super__setting_key,
                          'crm_setting_93'
                        )
                      "
                  /></label>
                  <button
                    class="tw-app-btn-primary-outline"
                    :class="{
                      disabled:
                        !dataFromSetting.crm_setting_93
                          .company_settings_super__setting_value,
                    }"
                    @click="
                      updateValue({
                        name: dataFromSetting.crm_setting_93
                          .company_settings_super__setting_key,
                        value: '',
                      })
                    "
                  >
                    Удалить файл
                  </button>
                </div>
              </div>
              <!-- загрузка звуковых оповещений -->
            </div>
          </div>
        </VTab>
      </VueTabs>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import StorageFileService from "@/api/StorageFileService";
export default {
  components: {
    VueTabs,
    VTab,
  },

  props: {},
  data() {
    return {
      localLoading: true,
      dataFromSetting: {},
      updatedValues: {},
      tariffsAndFineControlFields: [
        "crm_setting_81",
        "crm_setting_82",
        "crm_setting_83",
        "crm_setting_84",
        "crm_setting_85",
        "crm_setting_86",
        "crm_setting_87",
        "crm_setting_88",
        "crm_setting_89",
        "crm_setting_90",
        "crm_setting_91",
      ],
    };
  },
  methods: {
    uploadFile(e, key, odt) {
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      //определим тип
      let musicField = ["sound_file", "crm_setting_92", "crm_setting_93"];
      if (musicField.includes(odt)) {
        formData.append("type", "music");
      } else {
        formData.append("type", "default");
      }

      //пофиксим баг с выбором файла с тем же названием
      let fields = [
        "crm_setting_75",
        "sound_file",
        "crm_setting_92",
        "crm_setting_93",
      ];
      if (fields.includes(odt)) e.target.value = "";

      StorageFileService.upload(formData)
        .then((data) => {
          this.updateValue({ name: key, value: data.data.data.id });
          this.dataFromSetting[odt].company_settings_super__setting_value =
            data.data.data.url;
        })
        .catch((err) => {});
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value;
      this.dataFromSetting[data.name].company_settings_super__setting_value =
        data.value;
      if (data.name === "crm_setting_79" && !data.value.trim().length) {
        this.updatedValues.crm_setting_78 = 0;
        this.dataFromSetting.crm_setting_78.company_settings_super__setting_value = 0;
      }

      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.requestToPath, 2000);
    },
    requestToPath() {
      GeneralService.edit("/super/settings", this.updatedValues)
        .then((data) => {
          this.$toast.success(data.data.message);
        })
        .catch((err) => {
          this.$toast.success(err.response.data.message);
        });
      this.updatedValues = {};
    },
  },
  created() {
    GeneralService.get("/super/settings")
      .then((data) => {
        const rows = data.data?.data?.rows || data.data?.rows || data.rows;
        if (!rows || !Array.isArray(rows)) {
          this.localLoading = false;
          return;
        }
        rows.forEach((element) => {
          if (element && element.company_settings_super__setting_key) {
            let someData = {};
            someData[element.company_settings_super__setting_key] = {
              ...element,
            };
            this.dataFromSetting = Object.assign(
              {},
              this.dataFromSetting,
              someData
            );
          } else {
            console.warn("Элемент rows не содержит ключ", element);
          }
        });
        this.localLoading = false;
      })
      .catch((err) => {
        this.localLoading = false;
        this.dataFromSetting = {};
      });
  },

  computed: {
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("translationModule", ["dataLang"]),

    // ...mapState('bidsOsagoModule', [
    //   'bidsOsagoData',
    //   'bidsOsagoLoadStatus',
    //   'paginationbidsOsagoStateParams',
    // ]),
    // ...mapState('translationModule', ['dataLang']),
    // ...mapGetters('bidsOsagoModule', ['numPages']),
  },
};
</script>
